type ValidationResult = {
  isValid: boolean;
  error: string | undefined;
  content: string | undefined; // Parsed CSV content as an array of rows (each row is an array of strings)
};

export const processAndValidateCSV = (
  file: File,
): Promise<ValidationResult> => {
  return new Promise((resolve) => {
    // 1. Check MIME type and extension
    const validMimeTypes = ['text/csv', 'application/vnd.ms-excel'];
    const isValidMimeType = validMimeTypes.includes(file.type);
    const isValidExtension = file.name.toLowerCase().endsWith('.csv');

    if (!isValidMimeType && !isValidExtension) {
      resolve({
        isValid: false,
        error: 'The uploaded file is not a valid CSV file.',
        content: undefined,
      });
      return;
    }

    // 2. Check file size limit
    if (file.size > 5 * 1024 * 1024) {
      resolve({
        isValid: false,
        error: 'File size exceeds the 5MB limit.',
        content: undefined,
      });
      return;
    }

    // 3. Read the file content
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target?.result as string;

      // Check for empty file
      if (!content.trim()) {
        resolve({
          isValid: false,
          error: 'The uploaded file is empty.',
          content: undefined,
        });
        return;
      }

      // Return validation result and content
      resolve({
        isValid: true,
        error: undefined,
        content: content,
      });
    };

    reader.onerror = () => {
      resolve({
        isValid: false,
        error: 'An error occurred while reading the file.',
        content: undefined,
      });
    };

    reader.readAsText(file);
  });
};
